export default __webpack_public_path__ + "static/media/ticket-icon.9cb51959.png";